module.exports = __webpack_public_path__ + "media/customizations/dobsonranch/back-e307b93ec7d5d3527d0572b0311018cb.jpg";